import React from 'react';
import {Fragment} from "react";
import {encryptStorage} from "./utils/storage";
import Cookies from "js-cookie";


class Timer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hours : 0,
            minutes: 3,
            seconds: 0,
            timer: 180,
            colorBackground: null,
            isPaused: false
        }
    }

    componentDidMount() {
        this.initialState();
        window.addEventListener('beforeunload', () => {
        if(!encryptStorage.getItem('userdata')) {
            encryptStorage.setItem('userdata', this.props.user, false)
        }})
    }

    componentWillUnmount() {
        if(!encryptStorage.getItem('userdata')) {
            encryptStorage.setItem('userdata', this.props.user, false)
        }
    }
    initialState = () => {

        const initialTimer = 180;
        const hours = Math.floor(initialTimer / 3600);
        const minutes = Math.floor(initialTimer / 60) % 60;
        const seconds = initialTimer % 60;

        this.setState({
            timer: initialTimer,
            hours,
            minutes,
            seconds,
        }) ;


        this.props.setTimerApp(initialTimer)

    }

    decrementTimer = async () => {
        const newTimerValue = this.state.timer - 1;
        const hours = Math.floor(newTimerValue / 3600);
        const minutes = Math.floor(newTimerValue / 60) % 60;
        const seconds = newTimerValue % 60;

        // Update state with the new timer values
        this.setState({
            timer: newTimerValue,
            hours,
            minutes,
            seconds,
        });

        // Update parent component's timer (if needed)
        this.props.setTimerApp(newTimerValue);

        if(newTimerValue <= 0) {
            await this.props.sendForm();
            this.resetTimer();
        }

        else if(newTimerValue === 60) {
            this.setState({colorBackground : {background : "lightyellow"}})
        }

        else if(newTimerValue <= 15) {
                this.setState({colorBackground: {animation: "flicker 2s ease-in-out 7",
                    animationPlayState: "running"}})
            }

    };

    startTimer = () => {
        if (!this.state.intervalId) {
                this.props.handleTimer(false);
                this.props.updateForm(true);
                const intervalId = setInterval(this.decrementTimer, 1000);
                this.setState({intervalId});
        }
    };

    stopTimer = () => {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.setState({ intervalId: null });
        }
        this.props.handleTimer(true);
        this.props.updateForm(false);
        this.setState({colorBackground : {animationPlayState : "paused"}})
    };

    resetTimer = () => {
        this.setState({ timer: 180, hours: 0, minutes: 3, seconds: 0, colorBackground : null });
        encryptStorage.removeMultipleItems(['pokemonRec','timer','userdata']);
        Cookies.remove("record", {path : "/"})
        this.stopTimer();
        this.props.setTimerApp(180);
    };

    render() {
        const { hours, minutes, seconds, colorBackground, isPaused } = this.state;

        if (this.props.mode === 1) {
            return (
                <span className="containerTimer">

                    <div
                        className="timerHTML"
                        style={colorBackground}
                    >
                        <p>
                        {hours.toString().padStart(2, "0")}:
                        {minutes.toString().padStart(2, "0")}:
                        {seconds.toString().padStart(2, "0")}
                        </p>
                    </div>
                    <button type="button" id='timerOptions' onClick={() => this.setState( {isPaused : !isPaused}, () => isPaused ? this.startTimer() : this.stopTimer())}>
                        <span> {isPaused ? String.fromCodePoint(0x23F5) : String.fromCodePoint(0x23F8)} </span>
                    </button>
                </span>
            );
        }
        else { return (<></>)}
    }
}

export default React.forwardRef((props, ref) => <Timer ref={ref} {...props} />);
